<template>
  <div id="driver">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>运输溯源&nbsp;/&nbsp;司机管理</span>
      </div>
      <div style="display: flex; flex-wrap: wrap; align-items: center">
        <Provinces @gain="gainSS"></Provinces>
        <el-input
          class="elinputs"
          v-model="beginData.id"
          placeholder="搜索编号"
        ></el-input>
        <el-input
          class="elinputs"
          v-model="beginData.idCard"
          placeholder="身份证号码"
        ></el-input>
        <el-input
          class="elinputs"
          v-model="beginData.name"
          placeholder="司机姓名"
        ></el-input>
        <el-input
          class="elinputs"
          v-model="beginData.phone"
          placeholder="手机号"
        ></el-input>
        <el-button
          type="primary"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="query"
          >查询</el-button
        >
        <el-button type="info" @click="resets">重置</el-button>
      </div>
      <div class="tit">
        <Reset @clkBtn="theBtn"></Reset>
        <Xlsx :name="formname"></Xlsx>
      </div>
      <el-table
        :data="tableData"
        id="exportTab"
        @selection-change="handleSelectionChange"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column type="selection" width="60"></el-table-column>
        <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
        <el-table-column
          prop="name"
          label="司机姓名"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="idCard"
          label="身份证号码"
          width="260"
        ></el-table-column>
        <el-table-column
          prop="areasName"
          label="所属地区"
          min-width="160"
        ></el-table-column>
        <el-table-column label="性别" width="110">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.sex == 1">男</p>
            <p class="boldfont" v-if="scope.row.sex == 2">女</p>
          </template>
        </el-table-column>
        <el-table-column prop="age" sortable label="年龄" width="100"></el-table-column>
        <el-table-column
          prop="driveAge"
          label="驾龄"
          sortable
          width="100"
        ></el-table-column>
        <el-table-column label="驾驶证级别" width="160">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.driveLevel == 1">A1</p>
            <p class="boldfont" v-if="scope.row.driveLevel == 2">A2</p>
            <p class="boldfont" v-if="scope.row.driveLevel == 3">A3</p>
            <p class="boldfont" v-if="scope.row.driveLevel == 4">B1</p>
            <p class="boldfont" v-if="scope.row.driveLevel == 5">B2</p>
            <p class="boldfont" v-if="scope.row.driveLevel == 6">C1</p>
            <p class="boldfont" v-if="scope.row.driveLevel == 7">C2</p>
            <p class="boldfont" v-if="scope.row.driveLevel == 8">C3</p>
            <p class="boldfont" v-if="scope.row.driveLevel == 9">C4</p>
          </template>
        </el-table-column>
        <el-table-column label="驾驶证正面照片" width="200">
          <template slot-scope="scope">
            <viewer>
              <img class="sfzimg" :src="imgUrl + scope.row.licenseFrontPhoto" />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column label="驾驶证反面照片" width="200">
          <template slot-scope="scope">
            <viewer>
              <img class="sfzimg" :src="imgUrl + scope.row.licenseBackPhoto" />
            </viewer>
          </template>
        </el-table-column>

        <el-table-column label="是否显示" width="160">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.isDisplay">是</p>
            <p class="boldfont" v-else style="color: #f56c6c">否</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="addTime"
          label="添加时间"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改时间"
          width="180"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" min-width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(1, scope.row, 'driver:update')"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="stop(scope.row, 'driver:delete')"
              ><i class="el-icon-delete"></i> 删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span>
          共
          <i class="pagingNum">{{ total }}</i> 条
        </span>
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog
      :title="mydata.names"
      :visible.sync="dialogFormVisible"
      width="60%"
      @close="dataClose"
    >
      <el-form>
        <el-form-item label="* 所属地区：">
          <el-select v-model="sheng" placeholder="省份" @change="cksheng">
            <el-option
              v-for="item in shenglist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="shi"
            placeholder="城市"
            @change="ckshi"
            class="cty16"
          >
            <el-option
              v-for="item in shilist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 司 机：">
          <el-input
            placeholder="司机姓名"
            v-model="mydata.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 手机号：">
          <el-input
            placeholder="手机号"
            v-model="mydata.phone"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 身份证号：">
          <el-input
            placeholder="身份证号码"
            v-model="mydata.idCard"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 性 别：">
          <el-radio v-model="mydata.sex" label="1">男</el-radio>
          <el-radio v-model="mydata.sex" label="2">女</el-radio>
        </el-form-item>
        <el-form-item label="* 年 龄：">
          <el-input
            placeholder="年龄"
            type="number"
            v-model="mydata.age"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 驾 龄：">
          <el-input
            placeholder="驾驶年龄"
            type="number"
            v-model="mydata.driveAge"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 驾驶证级别：">
          <el-select v-model="mydata.driveLevel" placeholder="驾驶证级别选择">
            <el-option
              v-for="item in beginData.types"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 驾驶证正面照：">
          <el-upload
            class="upload-demo"
            :action="URL"
            :limit="1"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :data="newobj"
            ref="upload"
            :file-list="mydata.iconUrls"
            name="multipartFile"
            :headers="newhead"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传正面照</el-button>
            <div slot="tip" class="el-upload__tip">选择照片，大小2M以下</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="* 驾驶证反面照：">
          <el-upload
            class="upload-demo"
            :action="URL"
            :limit="1"
            :on-remove="handleRemove1"
            :on-success="handleAvatarSuccess1"
            :data="newobj"
            ref="uploads"
            :file-list="mydata.iconUrls1"
            name="multipartFile"
            :headers="newhead"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传反面照</el-button>
            <div slot="tip" class="el-upload__tip">选择照片，大小2M以下</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="* 是否显示：">
          <el-radio v-model="mydata.isDisplay" label="true">是</el-radio>
          <el-radio v-model="mydata.isDisplay" label="false">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="puton">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import EditorBar from "@/components/Richtext";
import Paging from "@/components/Paging";
export default {
  name: "driver",
  components: {
    Xlsx,
    EditorBar,
    Provinces,
    Reset,
    Paging,
  },
  data() {
    return {
      beginData: {
        sexs: [
          { id: 0, name: "男" },
          { id: 1, name: "女" },
        ],
        types: [
          { name: "A1", id: "1" },
          { name: "A2", id: "2" },
          { name: "A3", id: "3" },
          { name: "B1", id: "4" },
          { name: "B2", id: "5" },
          { name: "C1", id: "6" },
          { name: "C2", id: "7" },
          { name: "C3", id: "8" },
          { name: "C4", id: "9" },
        ],
      },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      userdata: {},
      total: 0,
      btn: [],
      fullscreenLoading: true,
      formname: JSON.stringify({ name: "司机管理", hint: "driver:export" }),
      imgUrl: this.$Public.imgUrl,
      URL: `${this.$Public.URL}/api-r/upload/uploadImg`,
      newobj: { type: 3 },
      newhead: {
        accessToken: JSON.parse(sessionStorage.getItem("userdata")).token,
      },
      sheng: "",
      shi: "",
      shenglist: [],
      shilist: [],
      mydata: { isDisplay: "true", iconUrls: [], iconUrls1: [] },
      multipleSelection: [],
    };
  },
  created() {
    let userdata = JSON.parse(sessionStorage.getItem("userdata"));
    this.$set(this, "userdata", userdata);
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    },
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem("region"));
    region.forEach((x) => {
      if (x.level == 0) {
        this.shenglist.push(x);
        this.sheng = x.id;
      }
    });
    if (this.userdata.level == 0) {
      this.$axios
        .post(
          `/api-r/area/getSubordinateAreaList`,
          this.$qs.stringify({ areasId: region[0].id }),
          { headers: { accessToken: this.userdata.token } }
        )
        .then((res) => {
          if (res.data.success) {
            this.$set(this, "shilist", res.data.areaListInfoList);
          }
        });
    } else {
      region.forEach((x) => {
        if (x.level == 1) {
          this.shilist.push(x);
        }
      });
      if (this.shilist.length == 1) {
        this.shi = this.shilist[0].id;
        this.mydata.areasId = this.sheng + "," + this.shilist[0].id;
        this.mydata.areasName = this.userdata.areasName;
      }
    }
  },
  methods: {
    resets() {
      this.$router.push("/refresh");
    },
    //   判断当前点击的按钮
    theBtn(i) {
      if (i == 1) {
        if (this.btn.indexOf("driver:add") == -1) {
          return this.$message("抱歉，用户暂无该权限");
        }
        this.handleEdit(0);
      } else if (i == 2) {
        if (this.btn.indexOf("driver:update") == -1) {
          return this.$message("抱歉，用户暂无该权限");
        }
        if (this.multipleSelection.length != 1) {
          return this.$message("请勾选一项内容编辑");
        }
        this.handleEdit(1, this.multipleSelection[0]);
      } else if (i == 3) {
        if (this.btn.indexOf("driver:delete") == -1) {
          return this.$message("抱歉，用户暂无该权限");
        }
        this.choice();
      } else if (i == 4) {
        this.query();
      }
    },
    // 获取省市传入的id
    gainSS(i) {
      this.userdata.areasId = i.id;
    },
    // 图片处理
    handleRemove(file, fileList) {
      this.mydata.licenseFrontPhoto = "";
    },
    handleAvatarSuccess(res, file) {
      this.mydata.licenseFrontPhoto = res.url;
    },
    // 图片处理
    handleRemove1(file, fileList) {
      this.mydata.licenseBackPhoto = "";
    },
    handleAvatarSuccess1(res, file) {
      this.mydata.licenseBackPhoto = res.url;
    },
    //   多选删除
    choice() {
      if (this.multipleSelection.length == 0) {
        return this.$message("请至少选择一项删除");
      }
      let arr = [];
      this.multipleSelection.forEach((x) => {
        arr.push(x.id);
      });
      this.$confirm("此操作将删除选中内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = ``;
          url = `/api-s/deleteLicense/${arr.join(",")}`;
          this.$axios
            .post(url, {}, { headers: { accessToken: this.userdata.token } })
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.begin();
              } else {
                alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    // 关闭清空内容
    dataClose() {
      if (this.shilist.length == 1) {
        this.mydata = {
          isDisplay: "true",
          iconUrls: [],
          iconUrls1: [],
          areasId: this.sheng + "," + this.shilist[0].id,
          areasName: this.userdata.areasName,
        };
      } else {
        this.shi = "";
        this.mydata = { isDisplay: "true", iconUrls: [], iconUrls1: [] };
      }
      this.begin();
    },
    cksheng(val) {
      this.$set(this, "shi", "");
    },
    ckshi(val) {
      this.mydata.areasId = this.sheng + "," + val;
      let arr = [];
      this.shenglist.forEach((x) => {
        if (this.sheng == x.id) {
          arr.push(x.name);
        }
      });
      this.shilist.forEach((x) => {
        if (val == x.id) {
          arr.push(x.name);
        }
      });
      this.mydata.areasName = arr.join(",");
    },
    //   多选编辑
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //   确定
    puton() {
      if (this.mydata.areasId == undefined || this.mydata.areasId == "") {
        return this.$message("请选择所属地区");
      }
      if (
        !this.mydata.name ||
        !this.mydata.phone ||
        !this.mydata.idCard ||
        !this.mydata.sex ||
        !this.mydata.age ||
        !this.mydata.driveAge ||
        !this.mydata.driveLevel ||
        !this.mydata.licenseFrontPhoto ||
        !this.mydata.licenseBackPhoto
      ) {
        this.$message("请完善必填信息");
        return;
      }
      if (this.$Public.checkPhone(this.mydata.phone) == false) {
        return this.$message("请输入正确的手机号");
      }
      if (this.$Public.isCardNo(this.mydata.idCard) == false) {
        return this.$message("请输入正确的身份证号码");
      }
      // 判断是点击哪个
      let url = ``;
      this.fullscreenLoading = true;
      if (this.mydata.stat == 0) {
        url = `/api-s/addLicense`;
      } else if (this.mydata.stat == 1) {
        url = `/api-s/updateLicense`;
      }
      this.$axios
        .post(url, this.$qs.stringify(this.mydata), {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.begin();
            this.dialogFormVisible = false;
          }
          this.$refs.upload.clearFiles();
          this.$refs.uploads.clearFiles();
        });
    },
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.begin();
    },
    begin() {
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id: this.beginData.id,
        idCard: this.beginData.idCard,
        name: this.beginData.name,
        phone: this.beginData.phone,
        adminAreasId: this.userdata.areasId,
      });
      this.$axios
        .post(`/api-s/getLicenseList`, data, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            this.$nextTick(function () {
              //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData", res.data.pageInfo.list);
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    handleEdit(i, row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      if (i == 0) {
        this.mydata.names = "添加司机";
        this.mydata.stat = i;
      } else if (i == 1) {
        row.names = "编辑司机";
        row.stat = i;
        row.sex += "";
        row.isDisplay += "";
        row.driveLevel += "";
        this.sheng = Number(row.areasId.split(",")[0]);
        this.shi = Number(row.areasId.split(",")[1]);
        row.iconUrls = [
          {
            name: "身份证正面照",
            url: `${this.imgUrl + row.licenseFrontPhoto}`,
          },
        ];
        row.iconUrls1 = [
          {
            name: "身份证反面照",
            url: `${this.imgUrl + row.licenseBackPhoto}`,
          },
        ];
        this.mydata = row;
      }
      this.dialogFormVisible = true;
    },
    // 删除
    stop(row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$confirm("此操作将删除该条内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = ``;
          url = `/api-s/deleteLicense/${row.id}`;
          this.$axios
            .post(url, {}, { headers: { accessToken: this.userdata.token } })
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.begin();
              } else {
                alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    },
  },
};
</script>
<style>
.w-e-toolbar {
  flex-wrap: wrap;
}
#driver .el-input__inner {
  margin: 10px 0;
}
#driver .el-menu.el-menu--horizontal {
  margin-bottom: 14px;
}
#driver .el-menu-item.is-active {
  background: none;
}
#driver .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#driver .el-tag {
  margin-right: 12px;
}
#driver .el-select {
  /* margin: 0 8px; */
  width: 100%;
}
#driver .el-upload__tip {
  display: inline-block;
  margin-left: 14px;
}
.input-new-tag {
  width: 20%;
}
#driver .el-upload-list--picture .el-upload-list__item {
  /* float: left;
    margin-right: 2%; */
}
#driver .el-form-item__content {
  display: flex;
  width: 100%;
}
#driver .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#driver .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#driver .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#driver .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#driver .el-dialog__body {
  height: 500px;
}
#driver .el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
#driver .el-form-item__label {
  width: 160px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx {
  color: red;
  margin-left: 8px;
}
.summary > span:first-child {
  margin-right: 20px;
}
.summary > span:first-child i {
  color: red;
}
.summary > span:last-child i {
  color: green;
}
.staimg {
  position: absolute;
  left: -26px;
  top: 10px;
  width: 18px;
}
.dtstat span {
  margin: 0 34px;
}
</style>
